import moment from 'moment';
import React, { useState } from 'react';
import { DayPickerSingleDateController, isInclusivelyAfterDay } from 'react-dates';
import styled from 'styled-components';
import Input from "../Input/Input.js";
var StyledWrapper = styled.div.withConfig({
  componentId: "CL__sc-sghock-0"
})(["width:100%;position:relative;.CalendarDay__selected,.CalendarDay__selected:active,.CalendarDay__selected:hover{background:var(--highlight-color);color:var(--main-bkg-color);border:1px double var(--highlight-color);}& > .DayPicker{margin-top:var(--spacing-2);}"]);
var StyledCalendarWrapper = styled.div.withConfig({
  componentId: "CL__sc-sghock-1"
})(["position:", ";padding-top:var(--spacing-2);z-index:9991;"], _ref => {
  var {
    positionCalendarAbsolutely
  } = _ref;
  return positionCalendarAbsolutely ? 'absolute' : 'relative';
});
var blocksDay = day => {
  var todayDate = moment();
  if (!isInclusivelyAfterDay(day, todayDate)) {
    return true;
  }
  return false;
};

/* hacked border css to override readonly styling */
var StyledInput = styled(Input).withConfig({
  componentId: "CL__sc-sghock-2"
})(["border:1px solid ", ";color:var(--text-color);", " ", ""], _ref2 => {
  var {
    intensity
  } = _ref2;
  return intensity === 'light' ? 'var(--border-color-dim)' : 'var(--border-color)';
}, _ref3 => {
  var {
    error
  } = _ref3;
  return error && "\n    &,\n    &:not(:disabled):hover,\n    &:not(:disabled):focus-visible {\n      border-color: var(--error-color);\n    }\n  ";
}, _ref4 => {
  var {
    disabled
  } = _ref4;
  return disabled && "border-color: var(--border-color-dim);";
});
var Datepicker = /*#__PURE__*/React.forwardRef((_ref5, ref) => {
  var {
    date,
    disabled = false,
    error = false,
    errorMessage,
    fieldSize = 'medium',
    fieldWidth = 'full',
    intensity = 'default',
    isOutsideRange = blocksDay,
    label = 'Choose a Date',
    labelledBy,
    message,
    name,
    numberOfMonths = 1,
    onDateChange,
    required = false,
    tabIndex = 0,
    id = name,
    positionCalendarAbsolutely = false,
    className
  } = _ref5;
  var [isFocused, setIsFocused] = useState(false);
  var [showCalendar, setShowCalendar] = useState(false);
  var momentDate = moment(date).startOf('day');
  var onDateChangeHandler = newMomentDate => {
    if (newMomentDate) {
      var newDate = newMomentDate.format('YYYY-MM-DD');
      onDateChange(newDate);
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    fieldWidth: fieldWidth,
    className: className
  }, /*#__PURE__*/React.createElement(StyledInput, {
    disabled: disabled,
    error: error,
    errorMessage: errorMessage,
    fieldSize: fieldSize,
    fieldWidth: fieldWidth,
    id: id,
    intensity: intensity,
    label: label,
    labelledBy: labelledBy,
    message: message,
    name: name,
    onFocus: () => setShowCalendar(true),
    readOnly: true,
    ref: ref,
    required: required,
    tabIndex: tabIndex,
    type: "text",
    value: momentDate.format('MM-DD-YYYY')
  }), showCalendar && /*#__PURE__*/React.createElement(StyledCalendarWrapper, {
    positionCalendarAbsolutely: positionCalendarAbsolutely
  }, /*#__PURE__*/React.createElement(DayPickerSingleDateController, {
    date: momentDate,
    focused: isFocused,
    onBlur: () => setShowCalendar(false),
    hideKeyboardShortcutsPanel: true,
    numberOfMonths: numberOfMonths,
    isOutsideRange: isOutsideRange,
    onDateChange: onDateChangeHandler,
    onFocusChange: _ref6 => {
      var {
        focused
      } = _ref6;
      setIsFocused(focused);
      setShowCalendar(false);
    },
    onOutsideClick: () => setShowCalendar(false),
    initialVisibleMonth: null
  })));
});
export default Datepicker;